import { Routes, Route } from "react-router-dom";
import MainPage from "./Pages/Mainp";
import LandingPage from "./Pages/landingpage";
import ProjectDetail from "./Pages/ProjectDetail";
// import Register from "./Pages/Register ";
// import Dashboard from "./Pages/Dashboard";
// import VotePage from "./Pages/candidates";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/portfolio" element={<LandingPage />} />
      <Route path="/portfolio/project/:slug" element={<ProjectDetail />} />
      {/* <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/votorpage" element={<VotePage></VotePage>}></Route>
      <Route path="/register" element={<Register />} /> */}
    </Routes>
  );
};

export default App;

